module.exports = __webpack_public_path__ + "img/mannequin-fm.ef287f60.jpeg";